import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";

import { getStaff } from "../../store/slices/staff";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";


export default function StaffId() {

  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});



  const [isGenerating, setIsGenerating] = useState(false);

  const [department, setDepartment] = useState("");
  const [staffId, setStaffId] = useState("");

  const [staff, setStaff] = useState([]);



  const validate = () => {

    const newErrors = {};
    if (!department) {
      newErrors.department = "Please select department";
    }
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleDepartmentChange = (e) => {

    const value = e.target.value;

    setDepartment(value);

    setStaffId("");

    setStaff([]);


    if (!value) {
      return;
    }


    dispatch(
      getStaff({
        department: value
      })
    )
      .unwrap()
      .then((res) => {

        console.log("STAFF RESPONSE:", res);

        setStaff(
          Array.isArray(res?.data)
            ? res.data
            : []
        );

      })
      .catch((err) => {

        toast.error(
          err?.message ||
          err ||
          "Failed to fetch staff"
        );

      });

  };


  const handleStaffChange = (e) => {

    setStaffId(
      e.target.value
    );

  };


  const waitForImages = async (container) => {

    const images = Array.from(
      container.querySelectorAll("img")
    );

    await Promise.all(

      images.map((img) => {

        if (img.complete) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {

          img.onload = resolve;
          img.onerror = resolve;

        });

      })

    );

  };


  /*
   * ==========================================
   * CREATE HTML ID CARD
   * ==========================================
   */
  const createIdCard = (
    staffMember,
    institute
  ) => {

    const card = document.createElement("div");

    card.style.width = "350px";
    card.style.height = "510px";
    card.style.background = "#ffffff";
    card.style.border = "1.5px solid #165A36";
    card.style.borderRadius = "12px";
    card.style.overflow = "hidden";
    card.style.display = "flex";
    card.style.flexDirection = "column";
    card.style.fontFamily = "Arial, sans-serif";
    card.style.boxSizing = "border-box";


    /* ==========================================
       HEADER
    ========================================== */

    const header =
      document.createElement("div");

    header.style.height = "80px";
    header.style.background = "#165A36";
    header.style.display = "flex";
    header.style.alignItems = "center";
    header.style.justifyContent = "center";
    header.style.padding = "0 5px";
    header.style.boxSizing = "border-box";


    const schoolName =
      document.createElement("div");

    schoolName.innerText =
      institute?.instituteName || "";

    schoolName.style.color = "#D4B15A";
    schoolName.style.fontSize = "24px";
    schoolName.style.fontWeight = "700";
    schoolName.style.textAlign = "center";
    schoolName.style.fontFamily =
      "Georgia, 'Times New Roman', serif";
    schoolName.style.lineHeight = "28px";

    header.appendChild(schoolName);
    card.appendChild(header);


    /* ==========================================
       ID TITLE
    ========================================== */

    const idTitle =
      document.createElement("div");

    idTitle.style.height = "35px";
    idTitle.style.background = "#D4B15A";
    idTitle.style.display = "flex";
    idTitle.style.alignItems = "center";
    idTitle.style.justifyContent = "center";


    const idTitleText =
      document.createElement("div");

    idTitleText.innerText =
      "STAFF ID CARD";

    idTitleText.style.fontSize = "18px";
    idTitleText.style.fontWeight = "bold";
    idTitleText.style.color = "#111111";

    idTitle.appendChild(idTitleText);
    card.appendChild(idTitle);


    /* ==========================================
       BODY
    ========================================== */

    const body =
      document.createElement("div");

    body.style.flex = "1";
    body.style.display = "flex";
    body.style.flexDirection = "column";
    body.style.alignItems = "center";
    body.style.paddingTop = "15px";
    body.style.boxSizing = "border-box";


    /* ==========================================
       PHOTO
    ========================================== */

    const photoContainer =
      document.createElement("div");

    photoContainer.style.width = "120px";
    photoContainer.style.height = "120px";
    photoContainer.style.border =
      "2px solid #165A36";
    photoContainer.style.borderRadius = "10px";
    photoContainer.style.padding = "4px";
    photoContainer.style.boxSizing = "border-box";
    photoContainer.style.display = "flex";
    photoContainer.style.alignItems = "center";
    photoContainer.style.justifyContent = "center";


    if (staffMember?.image) {

      const image =
        document.createElement("img");

      image.src =
        staffMember.image;

      image.crossOrigin =
        "anonymous";

      image.style.width = "100%";
      image.style.height = "100%";
      image.style.objectFit = "cover";
      image.style.borderRadius = "7px";

      photoContainer.appendChild(image);

    } else {

      const noPhoto =
        document.createElement("div");

      noPhoto.innerText =
        "PHOTO";

      noPhoto.style.width = "100%";
      noPhoto.style.height = "100%";
      noPhoto.style.background = "#eeeeee";
      noPhoto.style.borderRadius = "7px";
      noPhoto.style.display = "flex";
      noPhoto.style.alignItems = "center";
      noPhoto.style.justifyContent = "center";
      noPhoto.style.color = "#777777";
      noPhoto.style.fontSize = "12px";

      photoContainer.appendChild(
        noPhoto
      );

    }

    body.appendChild(
      photoContainer
    );


    /* ==========================================
       STAFF NAME
    ========================================== */

    const name =
      document.createElement("div");

    name.innerText =
      staffMember?.name || "";

    name.style.fontSize = "20px";
    name.style.fontWeight = "bold";
    name.style.color = "#8D244D";
    name.style.textAlign = "center";
    name.style.marginTop = "8px";
    name.style.padding = "0 8px";

    body.appendChild(name);


    /* ==========================================
       DEPARTMENT
    ========================================== */

    const department =
      document.createElement("div");

    department.innerText =
      staffMember?.department || "";

    department.style.fontSize = "17px";
    department.style.fontWeight = "bold";
    department.style.color = "#357347";
    department.style.marginTop = "4px";
    department.style.textAlign = "center";

    body.appendChild(department);


    /* ==========================================
       DESIGNATION
    ========================================== */

    if (staffMember?.designation) {

      const designation =
        document.createElement("div");

      designation.innerText =
        staffMember.designation;

      designation.style.fontSize = "14px";
      designation.style.fontWeight = "bold";
      designation.style.color = "#555555";
      designation.style.marginTop = "3px";
      designation.style.textAlign = "center";

      body.appendChild(
        designation
      );

    }


    /* ==========================================
       DETAILS
    ========================================== */

    const details =
      document.createElement("div");

    details.style.width = "90%";
    details.style.marginTop = "12px";
    details.style.textAlign = "center";
    details.style.color = "#111111";


    if (staffMember?.address) {

      const address =
        document.createElement("div");

      address.innerText =
        staffMember.address;

      address.style.fontSize = "13px";
      address.style.lineHeight = "1.2";
      address.style.marginTop = "3px";

      details.appendChild(
        address
      );

    }


    if (staffMember?.mobileNo) {

      const phone =
        document.createElement("div");

      phone.innerText =
        `Ph: ${staffMember.mobileNo}`;

      phone.style.fontSize = "14px";
      phone.style.fontWeight = "bold";
      phone.style.marginTop = "4px";

      details.appendChild(
        phone
      );

    }


    body.appendChild(
      details
    );

    card.appendChild(body);


    /* ==========================================
       FOOTER
    ========================================== */

    const footer =
      document.createElement("div");

    footer.style.height = "85px";
    footer.style.background = "#165A36";
    footer.style.color = "#ffffff";
    footer.style.display = "flex";
    footer.style.flexDirection = "column";
    footer.style.alignItems = "center";
    footer.style.justifyContent = "center";
    footer.style.padding = "5px 8px";
    footer.style.boxSizing = "border-box";


    const footerAddress =
      document.createElement("div");

    footerAddress.innerText =
      institute?.instituteAddress || "";

    footerAddress.style.fontSize = "12px";
    footerAddress.style.fontWeight = "bold";
    footerAddress.style.textAlign = "center";

    footer.appendChild(
      footerAddress
    );


    const location =
      document.createElement("div");

    location.innerText = [
      institute?.instituteCity,
      institute?.instituteState,
      institute?.institutePincode
    ]
      .filter(Boolean)
      .join(" - ");

    location.style.fontSize = "10px";
    location.style.textAlign = "center";
    location.style.marginTop = "2px";

    footer.appendChild(
      location
    );


    const contact =
      document.createElement("div");

    contact.innerText =
      `Ph: ${institute?.instituteMobileNo || ""} | Email: ${institute?.instituteEmail || ""}`;

    contact.style.fontSize = "10px";
    contact.style.textAlign = "center";
    contact.style.marginTop = "3px";
    contact.style.width = "100%";

    footer.appendChild(
      contact
    );


    card.appendChild(
      footer
    );


    return card;
  };

  /*
   * ==========================================
   * GENERATE PDF
   * ==========================================
   */

  const generateIdCardPDF = async (
    staffData,
    instituteData
  ) => {
    /*
     * Temporary container
     * outside the visible UI.
     */

    const container =
      document.createElement("div");

    container.style.position = "fixed";

    container.style.left = "-10000px";

    container.style.top = "0";

    container.style.width = "350px";

    container.style.background = "#ffffff";

    container.style.zIndex = "-1";


    document.body.appendChild(container);


    try {

      /*
       * Create cards
       */

      const cards =
        staffData.map((staffMember) => {

          const card =
            createIdCard(
              staffMember,
              instituteData
            );

          container.appendChild(card);

          return card;

        });


      /*
       * Wait for S3 images
       */

      await waitForImages(
        container
      );


      /*
       * Create A4 landscape PDF
       */

      const pdf =
        new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: "a4"
        });


      const pageWidth =
        pdf.internal.pageSize.getWidth();

      const pageHeight =
        pdf.internal.pageSize.getHeight();


      /*
       * ======================================
       * 4 X 2 GRID
       * ======================================
       */

      const marginX = 7;

      const marginY = 7;

      const gapX = 5;

      const gapY = 5;


      const cardWidth =
        (pageWidth -
          marginX * 2 -
          gapX * 3) / 4;


      const cardHeight =
        (pageHeight -
          marginY * 2 -
          gapY) / 2;


      /*
       * ======================================
       * EACH PAGE = 8 CARDS
       * ======================================
       */

      for (
        let i = 0;
        i < cards.length;
        i++
      ) {

        /*
         * New page after every 8 cards
         */

        if (
          i > 0 &&
          i % 8 === 0
        ) {

          pdf.addPage();

        }


        const position =
          i % 8;


        const column =
          position % 4;


        const row =
          Math.floor(position / 4);


        const x =
          marginX +
          column *
          (cardWidth + gapX);


        const y =
          marginY +
          row *
          (cardHeight + gapY);


        /*
         * Capture card
         */

        const canvas = await html2canvas(
          cards[i],
          {
            scale: 1.3,
            useCORS: true,
            allowTaint: false,
            backgroundColor: "#ffffff",
            logging: false
          }
        );

        const image = canvas.toDataURL(
          "image/jpeg",
          0.75
        );

        pdf.addImage(
          image,
          "JPEG",
          x,
          y,
          cardWidth,
          cardHeight,
          undefined,
          "FAST"
        );

      }


      /*
       * Download
       */

      pdf.save(
        "staff-id-cards.pdf"
      );

    } finally {

      /*
       * Remove temporary cards
       */

      document.body.removeChild(
        container
      );

    }

  };


  const handleSearch = async (e) => {

    e?.preventDefault();

    if (!validate()) {
      return;
    }

    setIsGenerating(true);

    try {

      const payload = {
        department,
      };

      if (staffId) {
        payload.id = staffId;
      }

      const response = await dispatch(
        getStaff(payload)
      ).unwrap();

      console.log("GET STAFF RESPONSE:", response);

      const staffData =
        Array.isArray(response?.data)
          ? response.data
          : [];

      const instituteData =
        response?.institute || {};

      if (!staffData.length) {

        toast.error("No staff found");

        return;
      }

      await generateIdCardPDF(
        staffData,
        instituteData
      );

      toast.success(
        "Staff ID card PDF generated successfully"
      );

    } catch (err) {

      console.error(
        "STAFF ID CARD ERROR:",
        err
      );

      toast.error(
        err?.message ||
        err ||
        "Failed to generate staff ID card"
      );

    } finally {

      setIsGenerating(false);

    }
  };


  return (
    <>

      <div className="page-header">

        <div className="breadcrumb-section">

          <div className="breadcrumb-left">

            <div className="home-icon">

              <Link to="/accounts/home">

                <FiHome
                  style={{
                    color: "white",
                    marginTop: "-4px"
                  }}
                />

              </Link>

            </div>

            <FiChevronRight
              className="separator"
            />

            <span className="active">
              Staff ID Card
            </span>

          </div>

        </div>

      </div>


      <div className="acs-card">

        <Form onSubmit={handleSearch}>
          <Row className="g-3">

            {/* ================================
      DEPARTMENT
  ================================= */}

            <Col md={3}>

              <Form.Group>

                <Form.Label>
                  Department
                </Form.Label>

                <Form.Select
                  value={department}
                  onChange={(e) => {

                    handleDepartmentChange(e);

                    setErrors((prev) => ({
                      ...prev,
                      department: ""
                    }));

                  }}
                >

                  <option value="">
                    Select Department
                  </option>

                  <option value="Teaching">
                    Teaching
                  </option>

                  <option value="Non Teaching">
                    Non Teaching
                  </option>

                  <option value="Accounts">
                    Accounts
                  </option>

                  <option value="Management">
                    Management
                  </option>

                  <option value="Transport">
                    Transport
                  </option>

                  <option value="Co-Ordinator">
                    Co-Ordinator
                  </option>

                  <option value="House Keeping">
                    House Keeping
                  </option>

                </Form.Select>

                {errors.department && (

                  <div className="text-danger mt-1">
                    {errors.department}
                  </div>

                )}

              </Form.Group>

            </Col>


            {/* ================================
      STAFF
  ================================= */}

            <Col md={3}>

              <Form.Group>

                <Form.Label>
                  Staff
                </Form.Label>

                <Form.Select
                  value={staffId}
                  disabled={!department}
                  onChange={handleStaffChange}
                >

                  <option value="">
                    All Staff
                  </option>

                  {staff.map((item) => (

                    <option
                      key={item._id}
                      value={item._id}
                    >
                      {item.name}
                    </option>

                  ))}

                </Form.Select>

              </Form.Group>

            </Col>

          </Row>


          <Row className="mt-5">

            <Col className="d-flex justify-content-center">

              <button
                type="button"
                className="btn-submit"
                style={{
                  width: "150px"
                }}
                onClick={handleSearch}
                disabled={isGenerating}
              >

                {isGenerating
                  ? "Preparing..."
                  : "Generate PDF"}

              </button>

            </Col>

          </Row>

        </Form>

      </div>

    </>
  );
}